var allExploreLists = function () {

    function pageBodyLoad() {
        checkUserStatus();
    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            getUserStatusLoad(JSON.parse(response));
        }

        const checkUserStatusError = function () {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    function getUserStatusLoad(response) {
        // Valid user
        if (response.logged_in == true) {
            coreFunctions.userguidingSetup(response);
            exploreLists.getExploreLists();
        }
        //
        else {
            requireLogin();
        }
    }

    class ExploreLists {
        constructor() {
            this.exploreLists = [];
        }

        getExploreLists() {
            let method, url;
            const exploreListsObject = this;

            method = "POST";
             url = "../api/lists/lists_actions.php?action=getexplorelists";


            const getExploreListsSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    response.exploreLists.forEach(list => exploreListsObject.newExploreList(list.listID, list.listName, list.notes, list.listCreated, list.listEdited));
                    exploreListsObject.addListElementsToPage().loadComplete();
                }
            }

            const getExploreListsError = function () {
                console.log("Error obtaining explore lists");
                exploreListsObject.loadComplete();
            }

            coreFunctions.xhrHelper(method, url, getExploreListsSuccess, getExploreListsError);
        }

        newExploreList(listID, name, notes, created, edited) {
            const exploreList = new ExploreList(listID, name, notes, created, edited);
            this.exploreLists.push(exploreList);
            return exploreList;
        }

        addListElementsToPage() {
            if (this.exploreLists.length > 0) {
                this.exploreLists.forEach(list => list.addListElementToPage());
            } else {
                this.noExploreLists();
            }
            return this
        }

        noExploreLists() {
            // No saved lists
            document.querySelector(".existingListsHolder").appendChild(coreFunctions.createElementHelper("p", { class: "noRecent", innerHTML: "You do not currently have any saved Explore lists." }));
            document.getElementById("listSearchWrapper").classList.add("hidden");
            return this;
        }

        loadComplete() {
            main.classList.remove("mainHidden");
            if (getQueryVariable("searchfocus")) {
                document.getElementById("listSearchInput").focus();
            }
            return this;
        }

        searchExploreLists(value) {
            let listSearchString, totalLists;

            listSearchString = value.toLowerCase();
            totalLists = this.exploreLists.length;

            for (var i = 0; i < totalLists; i++) {
                this.exploreLists[i].searchList(listSearchString);
            }

            // No lists pass the search criteria
            if (document.querySelector(".existingList:not(.hidden)") == undefined) {
                document.getElementById("listSearchNoResults").classList.remove("hidden");
            } else {
                document.getElementById("listSearchNoResults").classList.add("hidden");
            }
        }

        resetExploreLists() {
            this.exploreLists.forEach(list => list.displayListControls());
        }

        editExploreList(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("editExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=edit&listid=${Number(input.get('listID'))}`;

            const editExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    exploreListsObject.exploreLists.find(list => list.listID == response.listID).editExploreListLoad(response);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const editExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListError(response);
            }

            coreFunctions.xhrHelper(method, url, editExploreListSuccess, editExploreListError, input);
        }

        editExploreListNotes(form) {
            let input, method, url;
            const exploreListsObject = this;

            document.getElementById("notesExploreListSubmitButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=notes&listid=${Number(input.get('listID'))}`;

            const notesExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                if (response.status == "success") {
                    document.getElementById("notesExploreListSubmitButton").disabled = false;

                    // Update the notes with the filtered response
                    document.querySelector("#notesExploreListForm textarea[name='notes']").value = response.notes;
                    exploreListsObject.exploreLists.find(list => list.listID == response.listID).notes = response.notes;

                    // Hide form and display success message
                    coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                    coreFunctions.showStatusMessage(response.title, response.message);
                } else {
                    exploreListsObject.editListError(response);
                }
            }

            const notesExploreListError = function () {
                const response = {
                    status: "error",
                    title: "Error",
                    message: "Could not edit explore list."
                }
                exploreListsObject.editListNotesError(response);
            }

            coreFunctions.xhrHelper(method, url, notesExploreListSuccess, notesExploreListError, input);
        }

        editListNotesError(response) {
            // Remove in progress class from button
            document.getElementById("notesExploreListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#notesExploreListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("notesExploreListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        editListError(response) {
            // Remove in progress class from button
            document.getElementById("editListSubmitButton").disabled = false;

            if (response.input_error && response.input_error.length > 0) {
                // Update page with any input errors
                document.querySelector("#editListForm .input_error").innerHTML = response.input_error;
            } else {
                // Hide form and display error message
                coreFunctions.hideOverlay(document.getElementById("editListForm"));
                coreFunctions.showStatusMessage(response.title, response.message);
            }
        }

        clearEditExploreListInputError() {
            document.querySelector("#editExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        clearNotesExploreListInputError() {
            document.querySelector("#notesExploreListForm .input_error").innerHTML = "&nbsp;";
        }

        copyExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("copyExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
             url = `../api/explore/explore_actions.php?action=copy&listid=${Number(input.get('listID'))}`;

            const copyExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.copyExploreListLoad(response);
            }

            const copyExploreListError = function () {
                const response = {
                    status: "error",
                    title: "List copy error",
                    message: "Sorry, your list could not be copied at this time."
                }
                listsObject.copyExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, copyExploreListSuccess, copyExploreListError, input);

        }

        copyExploreListLoad(response) {
            document.getElementById("copyExploreListButton").disabled = false;
            if (response.status == "success") {
                this.newExploreList(response.listID, response.listName, '', response.listCreated, response.listEdited).addListElementToPage(true);
            }
            coreFunctions.hideOverlay(document.getElementById("copyExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        deleteExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("deleteExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=delete&listid=${Number(input.get('listID'))}`;

            const deleteExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.deleteExploreListLoad(response);
            }

            const deleteExploreListError = function () {
                const response = {
                    status: "error",
                    "title": "Error",
                    "message": "Sorry, could not delete Explore list."
                }
                listsObject.deleteExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, deleteExploreListSuccess, deleteExploreListError, input);

        }

        deleteExploreListLoad(response) {
            document.getElementById("deleteExploreListButton").disabled = false;

            if (response.status == "success") {
                this.exploreLists.find(list => list.listID == response.listID).deleteExploreListControlElementFromPage();
            }

            coreFunctions.hideOverlay(document.getElementById("deleteExploreListButton"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        shareExploreList(form) {
            let input, method, url;
            const listsObject = this;

            document.getElementById("shareExploreListButton").disabled = true;

            input = new FormData(form);
            method = "POST";
            url = `../api/explore/explore_actions.php?action=share&listid=${Number(input.get('listID'))}`;

            const shareExploreListSuccess = function (responseText) {
                const response = JSON.parse(responseText);
                listsObject.shareExploreListLoad(response);
            }

            const shareExploreListError = function () {
                const response = {
                    status: "error",
                    input_errors: {
                        email: "&nbsp;",
                        general: "Could not share list. An unexpected error occurred. Please try again."
                    }
                }
                listsObject.shareExploreListLoad(response);
            }

            coreFunctions.xhrHelper(method, url, shareExploreListSuccess, shareExploreListError, input);
        }

        // Clear input errors
        resetShareExploreListInputErrors() {
            document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = "&nbsp;";
            document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = "&nbsp;";
        }

        shareExploreListLoad(response) {
            document.getElementById("shareExploreListButton").disabled = false;
            if (response.status == "success") {
                coreFunctions.hideOverlay(document.getElementById("shareExploreListButton"));
                showStatusMessage(response.title, response.message);
            } else {
                document.querySelector("#shareExploreListForm .input_error[field='email']").innerHTML = response.input_errors.email;
                document.querySelector("#shareExploreListForm .input_error[field='general']").innerHTML = response.input_errors.general;
            }
        }

    }

    class ExploreList {
        constructor(listID, name, notes, created, edited) {
            this.listID = listID;
            this.name = name;
            this.notes = notes;
            this.created = created;
            this.edited = edited;
        }

        addListElementToPage(copiedList) {
            let existingList, actionsHolder, listDetailsElement, listBuiltWithCurrentVersion, listActionsControlLabel, accordianListMain;
            const listObject = this;

            // Ascensor
            existingList = coreFunctions.createElementHelper("li", { class: "existingList", list_id: this.listID });

            accordianListMain = existingList.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-list-main"}));

            accordianListMain.appendChild(coreFunctions.createElementHelper("div", {class: "accordian-control-holder"})).appendChild(coreFunctions.createElementHelper("button", { class: "actionControl extraDetailsButton", innerHTML: "&nbsp;" }, { click: function () { listObject.extraDetailsButtonClick(this) } }));

            listDetailsElement = accordianListMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-list-name listDetailsElement" }));

            actionsHolder = accordianListMain.appendChild(coreFunctions.createElementHelper("div", { class: "accordian-control-holder actionsHolder" }));

            listDetailsElement.appendChild(coreFunctions.createElementHelper("a", { class: "existingListName", href: `${urlPath}/explore?list_id=${this.listID}`, innerHTML: `${this.name}${(copiedList) ? " <strong>*New</strong>" : ""}` }));

            existingList.appendChild(this.addListExtraDetails());

            actionsHolder.appendChild(coreFunctions.createElementHelper("input", { class: "listActionsControl", type: "checkbox", id: `listActionsControl-${this.listID}` }, { change: function () { listObject.listActionsControlOnChange(this); } }));

            listActionsControlLabel = actionsHolder.appendChild(coreFunctions.createElementHelper("label", { class: "listActionsControlLabel", for: `listActionsControl-${this.listID}` }));

            listActionsControlLabel.appendChild(coreFunctions.createElementHelper("span", { "class": "controlsToggle", innerHTML: "&nbsp;" }));

            listActionsControlLabel.appendChild(this.createListActionsControls());

            if (copiedList) {
                document.querySelector(".existingListsHolder").insertBefore(existingList, document.querySelector(".existingListsHolder").firstElementChild)
            } else {
                document.querySelector(".existingListsHolder").appendChild(existingList);
            }
        }

        listActionsControlOnChange(element) {
            let activeActionTab
            if (activeActionTab = document.querySelector(`.existingListsHolder input.listActionsControl:not(#${element.id}):checked`)) {
                activeActionTab.checked = false;
            }
        }

        createListActionsControls() {
            let actionsHolder;
            const listObject = this;

            actionsHolder = coreFunctions.createElementHelper("span", { class: "controls" });

            actionsHolder.appendChild(coreFunctions.createElementHelper("a", { innerHTML: "<span>Analyse</span>", class: "actionControl list-insights", title: "List insights", href: `${urlPath}/analyse?explorelist_id=${this.listID}` }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Edit name</span>", class: "actionControl edit-list", title: "Edit list" }, { click: function () { listObject.updateEditExploreListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Notes</span>", class: "actionControl edit-notes", title: "Edit notes" }, { click: function () { listObject.updateEditNotesExploreListOverlay() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Make a copy</span>", title: "Copy list", class: "actionControl copy-list" }, { click: function () { listObject.copyExploreListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Share</span>", title: "Share list", class: "actionControl share-list" }, { click: function () { listObject.shareListControlAction() } }));

            actionsHolder.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "<span>Delete</span>", title: "Delete list", class: "actionControl delete-list" }, { click: function () { listObject.deleteExploreListButtonClick() } }));

            return actionsHolder;
        }

        addListExtraDetails() {
            let extraDetailsHolder = coreFunctions.createElementHelper("ul", { class: "extraDetailsHolder accordian-list-details" });

            extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Created</div><div class='field'>${moment(this.created, "YYYY-MM-DD").format("DD/MM/YY")}</div>` }));

            if (this.edited) {
                extraDetailsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: `<div class='label'>Last edited</div><div class='field'>${moment(this.edited, "YYYY-MM-DD HH:mm:ss").format("HH:mm DD/MM/YY")}</div>` }));
            }

            return extraDetailsHolder;
        }

        extraDetailsButtonClick(element) {
            let listContent = element.closest(".existingList");
            if (listContent.classList.contains("extraDetailsVisible")) {
                listContent.classList.remove("extraDetailsVisible");
            } else {
                listContent.classList.add("extraDetailsVisible");
            }
        }

        searchList(listSearchString) {
            if (this.name.toLowerCase().includes(listSearchString)) {
                this.displayListControls();
            } else {
                this.hideListControls();
            }
        }

        displayListControls() {
            document.querySelector(`.existingList[list_id='${this.listID}']`).classList.remove("hidden");
        }

        hideListControls() {
            document.querySelector(`.existingList[list_id='${this.listID}']`).classList.add("hidden");
        }

        updateEditExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearEditExploreListInputError();
            document.querySelector("#editExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#editExploreListForm input[name='listName']").value = this.name;
            coreFunctions.showOverlay("editexplorelist");
        }

        editExploreListLoad(response) {
            // Remove in progress class from button
            document.getElementById("editExploreListSubmitButton").disabled = false;

            this.name = response.listName;
            // Update title on select page with new text
            document.querySelector(`.existingList[list_id='${this.listID}'] .existingListName`).innerHTML = this.name;
            // Hide form and display success message
            coreFunctions.hideOverlay(document.getElementById("editExploreListForm"));
            coreFunctions.showStatusMessage(response.title, response.message);
        }

        updateEditNotesExploreListOverlay() {
            // Hide previous input errors
            exploreLists.clearNotesExploreListInputError();
            document.querySelector("#notesExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#notesExploreListForm textarea[name='notes']").value = this.notes;
            coreFunctions.showOverlay("notesexplorelist");
        }

        copyExploreListControlAction() {
            document.getElementById("exploreListToCopyTitle").innerHTML = this.name;
            document.querySelector("#copyExploreListForm input[name='listName']").value = `${this.name} copy`;
            document.querySelector("#copyExploreListForm input[name='listID']").value = this.listID;
            coreFunctions.showOverlay("copyexplorelist");
        }

        deleteExploreListButtonClick() {
            document.getElementById("exploreListDeleteWarningTitle").innerHTML = `Confirm "${this.name}" deletion`;
            document.querySelector("#deleteExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#deleteExploreListForm input[name='name']").value = this.name;
            coreFunctions.showOverlay("deleteexplorelistpanel");
        }

        deleteExploreListControlElementFromPage() {
            document.querySelector(".existingListsHolder").removeChild(document.querySelector(`.existingList[list_id='${this.listID}']`));
            if (document.getElementById("existingExploreLists").children.length == 0) {
                exploreLists.noExploreLists();
            }
        }

        shareListControlAction() {
            document.querySelector("#shareExploreListForm input[name='listID']").value = this.listID;
            document.querySelector("#shareExploreListForm input[name='listName']").value = this.name;
            exploreLists.resetShareExploreListInputErrors();
            coreFunctions.showOverlay("shareexplorelist");
        }
    }

    const exploreLists = new ExploreLists();

    // Public functions
    return {
        pageBodyLoad: pageBodyLoad,
        exploreLists: exploreLists
    }

}();
